import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../lib/UserContext";
import axios from "axios";

const Profile = () => {
  const navigate = useNavigate();
  const [imageUrls, setImageUrls] = useState([]);

  const [user, setUser] = useContext(UserContext);
  
  useEffect(() => {
     user && !user.userId && !user.userName && navigate("/login");
  }, [user, navigate]);

  // Redirect to login page if not loading and no user found
  useEffect(() => {
    const fetchImageUrls = async () => {
      console.log("user",user);
      const user_id = user.userId;
      
      const response = await axios.get(process.env.REACT_APP_SERVER_URL+'/mentedImages', {
        params: {
          user_id: user_id,
        },
      });
      console.log("images",response.data.data.imageUrls);
      setImageUrls(response.data.data.imageUrls);
    };
    fetchImageUrls();
  }, [user, navigate]);

  const logoutUser = () => {
    setUser({"userId":null, "userName":null, "magicLinkAccount":null})
  }

  return (
    <>
      <div className="bg-header h-screen font-inter">
        <div className="px-6 pt-6 lg:px-8">
          <nav className="flex items-center justify-between">
            <div className="flex lg:flex-1">
              <a href="" className="-m-1.5 p-1.5">
                <span className="sr-only">Celium</span>
                <img
                  className="h-14"
                  src={"image/celium-white.png"}
                  alt="celium-logo"
                />
              </a>
            </div>
              <div>
                <button onClick={() => navigate('/profile')} className="mr-5">Profile</button>
<button onClick={logoutUser}>Logout</button>
              </div>
          </nav>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-20 bg-white px-20 vh-100">
          <div className="col-start-1 p-5">
            <img
              src={"image/profile.png"}
              width={150}
              height={150}
              alt=""
              className="rounded-full -mt-20"
            />
            <h2 className="text-black mt-5">{user.userName}</h2>
            <button onClick={() => navigate("/editProfile")} className="text-black border-2 border-black font-bold px-10 py-3">
              Edit Profile
            </button>
            <h2 className="text-black mt-10 font-bold">Completed Tests</h2>
            <button onClick={() => navigate("/values")} className="text-black border-2 border-black font-bold px-10 py-3">
              The First Value
            </button>
          </div>
          <div className="p-5 col-start-2 col-span-2">
            <h2 className="text-black font-bold text-2xl mb-5">
              Glyph Collection
            </h2>
            <div className="grid grid-cols-2 gap-4">
            {imageUrls.map((imageUrl, index) => (
              <div className="bg-gray-800 text-white rounded-b-xl" key={index}>
                <img src={imageUrl} className="w-full" alt="" />
                <div className="p-3 border-t-2 border-gray-500">
                  <h3 className="font-bold">The First Values</h3>
                  <p>Free</p>
                  <p>Minted</p>
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;